// track/components/AddMethodModal.tsx
import React, { useState } from 'react';
import { TransactionMethod } from '../types';

interface AddMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddMethod: (methodData: { name: string; type: 'bank' | 'credit_card' | 'cash' | 'other'; accountNumber?: string }) => void;
  isLoading: boolean;
}

const AddMethodModal: React.FC<AddMethodModalProps> = ({ isOpen, onClose, onAddMethod, isLoading }) => {
  const [newMethod, setNewMethod] = useState({
    name: '',
    type: 'bank' as 'bank' | 'credit_card' | 'cash' | 'other',
    accountNumber: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newMethod.name) return;
    onAddMethod(newMethod);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Add Source</h3>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Source Name</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                placeholder="e.g., Business Current Account"
                value={newMethod.name}
                onChange={(e) => setNewMethod({ ...newMethod, name: e.target.value })}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
              <select
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                value={newMethod.type}
                onChange={(e) => setNewMethod({ ...newMethod, type: e.target.value as 'bank' | 'credit_card' | 'cash' | 'other' })}
              >
                <option value="bank">Bank Account</option>
                <option value="credit_card">Credit Card</option>
                <option value="cash">Cash</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Account Number (optional)</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                placeholder="Last 4 digits"
                value={newMethod.accountNumber}
                onChange={(e) => setNewMethod({ ...newMethod, accountNumber: e.target.value })}
              />
            </div>
          </div>
          <div className="flex space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!newMethod.name || isLoading}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400"
            >
              {isLoading ? 'Adding...' : 'Add Source'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMethodModal;